/// ----------------------------------------------------------------------------------------
///Copyright (C) 2016 to the present, Crestron Electronics, Inc.
///All rights reserved.
///No part of this software may be reproduced in any form, machine
///or natural, without the express written consent of Crestron Electronics. 
/// ----------------------------------------------------------------------------------------
/// <file>
/// <name>device-category-collection.model.ts</name>
///
/// <description>
///  
/// </description>
///
/// <author>Michael Martinez</author>
/// <created>30 Aug 2016</created>
///
/// <changelog>
///   Date  Who Version     Flag Comments
/// ======= === =========== ==== ===========================================================
/// 30Aug16 MM  1.0.0000         First cut
/// </changelog>
///
/// </file>
/// ----------------------------------------------------------------------------------------
import {DeviceControlType } from  './device-control-type.model'; 
import {DeviceControlModel } from  './device-control.model'; 
import {DeviceCategoryModel } from  './device-category.model'; 
import {DeviceApiService,
    Device,
    DeviceList,
    DevicesSearch,
    DeviceOperation,
    OperationEnum,
    MergeAction,
    DeliveryStateEnum,
    Settings,
    General,
    RunTimeSettings,
    TimeOptions,
    FusionSetup,  
    AirMedia,
    Scheduling, 
    SIP
} from '../../services/Crestron.HydrogenAPI.DeviceApi.service';
 

export class DeviceCategoryCollectionModel extends Array<DeviceCategoryModel>  { 
    id: string;
    action: MergeAction;

}



// WEBPACK FOOTER //
// C:/WS/Fusion/FusionDashboard/src/app/models/device-data-models/device-category-collection.model.ts